import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { ClearCacheRequest, DataCleanupActionRequest, DataCleanupAnalyzeResult, DataCleanupResponse } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MaintenanceEndpoints extends ApiBase {
  public analyze(): Observable<DataCleanupAnalyzeResult> {
    return this.get<DataCleanupAnalyzeResult>(`/maintenance/game/${this.gameId}/${this.dataPackage}/data-cleanup/analyze`);
  }

  public performDataCleanup(actions: DataCleanupActionRequest[]): Observable<DataCleanupResponse> {
    return this.post<DataCleanupResponse>(`/maintenance/game/${this.gameId}/${this.dataPackage}/data-cleanup`, actions);
  }

  public clearCache(): Observable<void> {
    return this.post<void>(`/maintenance/clear-cache`, {});
  }

  public clearMediaCache(request: ClearCacheRequest = { dataPackageUid: this.dataPackage }): Observable<void> {
    return this.post<void>(`/maintenance/clear-media-cache`, request);
  }

  public rebuildMediaCache(): Observable<void> {
    return this.post<void>(`/maintenance/game/${this.gameId}/${this.dataPackage}/rebuild-media-cache`, {});
  }
}
